import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import PrivacyPolicy from "../pages/privacy-policy/page";
import LegalNotice from "../pages/legal-notice/page";
import CookiesPolicy from "../pages/cookies-policy/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/politica-de-privacidad",
    element: <PrivacyPolicy />,
  },
  {
    path: "/aviso-legal",
    element: <LegalNotice />,
  },
  {
    path: "/politica-de-cookies",
    element: <CookiesPolicy />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
